import get from 'lodash/get';
import {useState} from 'react';

import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import FindPatientForm from '../patients/FindPatientForm';
import MessageUserButton from '../messages/MessageUserButton';
import SchedulePatientButton from '../patients/SchedulePatientButton';
import ViewPatientButton from '../patients/ViewPatientButton';
import PropTypes from "prop-types";
import useIsMobile from "../../hooks/useIsMobile";
import useUser from '../../hooks/useUser';
import {useGetPatientsQuery} from '../../redux/services/patientApi';

const getOptions = patients => (
  (patients || []).map(p => ({
    label: `${p.user.first_name} ${p.user.last_name}`,
    value: p.id,
  }))
);

const handleTextChange = ({setTextInput, setQuery}) => e => {
  const value = get(e, 'target.value', '');
  setTextInput(value);
  setQuery({text: value});
};

const SelectPatientDialog = props => {
  const isMobile = useIsMobile();
  const [selectedPatientId, setSelectedPatientId] = useState(null);
  const onSubmit = ({patientId}) => setSelectedPatientId(patientId);
  const title = (
    props.title ? props.title :
    props.messagePageAccess ? 'Search Patients' : 'Schedule with a Patient'
  );
  const user = useUser();
  const selectedPatientQuery = useGetPatientsQuery(
    {id: selectedPatientId, hide_details: true}, 
    {skip: !selectedPatientId,}
  );
  const selectedPatient = selectedPatientQuery?.data?.data?.[0];
  const isMyPatient = !!(selectedPatient?.providers || []).find(p => p.id === user?.provider?.id);
  console.log('isMyPatient', isMyPatient, selectedPatient, user?.provider?.id);
  return (
    <Box>
      <Stack spacing={2} padding={2}>
        <Typography
          variant='h2'
          align='center'
          style={{paddingTop: '0.25em', paddingBottom: '0.5em'}}
          defaultValue={selectedPatientId}
        >
          {title}
        </Typography>
        <Divider />
        <Stack direction='row' padding={1} justifyContent='center'>
          <FindPatientForm 
              freeSolo={true}
              disableClearable={true}
              autoFocus={true}
              allPatients={true}
              onSubmit={onSubmit}
          />
        </Stack>
        <Stack padding={1} sx={{
          minHeight: 100,

        }}>
          {
            selectedPatientId
            ? <Stack gap={1}>
                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent='center' spacing={1}>
                  <MessageUserButton 
                    patientId={selectedPatientId}
                    variant='primaryGradient'
                    size={isMobile ? 'small' : 'large'}
                  />
                  <SchedulePatientButton 
                    patientId={selectedPatientId}
                    variant='secondaryGradient'
                    size={isMobile ? 'small' : 'large'}
                  />
                </Stack>
                {isMyPatient && 
                  <Stack direction='row' justifyContent='center'>
                    <ViewPatientButton patientId={selectedPatientId} variant='text' />
                  </Stack>
                }
              </Stack>
            : null
          }
        </Stack>
      </Stack>
    </Box>
  );
};

SelectPatientDialog.propTypes = {
  title: PropTypes.string,
  messagePageAccess: PropTypes.bool,
};

export default SelectPatientDialog;
